/* ============================================================
   Luna Store — Vanilla JS Interactivity
   ============================================================ */

(function () {
  'use strict';

  /* ── Cart Drawer ──────────────────────────────────────────── */
  const cartBackdrop = document.querySelector('.luna-cart-backdrop');
  const cartDrawer = document.querySelector('.luna-cart-drawer');
  const cartToggles = document.querySelectorAll('[data-cart-toggle]');
  const cartCloses = document.querySelectorAll('[data-cart-close]');
  const cartBadge = document.querySelector('.luna-cart-toggle__badge');

  function openCart() {
    cartBackdrop?.classList.add('open');
    cartDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    cartBackdrop?.classList.remove('open');
    cartDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartToggles.forEach((btn) => btn.addEventListener('click', openCart));
  cartCloses.forEach((btn) => btn.addEventListener('click', closeCart));
  cartBackdrop?.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeCart();
  });

  /* ── Add to Cart (Shopify AJAX API) ──────────────────────── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-add-to-cart]');
    if (!btn) return;

    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.classList.add('added');
    const originalHTML = btn.innerHTML;
    btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg> Adicionado!';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });

      if (res.ok) {
        updateCartUI();
        setTimeout(() => {
          btn.classList.remove('added');
          btn.innerHTML = originalHTML;
          btn.disabled = false;
        }, 1800);
      } else {
        btn.innerHTML = originalHTML;
        btn.disabled = false;
      }
    } catch {
      btn.innerHTML = originalHTML;
      btn.disabled = false;
    }
  });

  /* ── Buy now (add then go straight to checkout) ──────────── */
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-buy-now]');
    if (!btn) return;

    e.preventDefault();
    const variantId = btn.dataset.variantId;
    if (!variantId) { window.location.href = '/cart'; return; }

    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.6';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] }),
      });
      if (res.ok) {
        /* /cart deixa o interceptador de checkout (Yampi) assumir; com
           "pular carrinho" ativo, o redirect ao checkout é automático */
        window.location.href = '/cart';
        return;
      }
    } catch { /* fall back to href below */ }

    /* Fallback: valid cart permalink */
    window.location.href = btn.getAttribute('href') || ('/cart/' + variantId + ':1');
  });

  /* ── Update Cart UI ──────────────────────────────────────── */
  async function updateCartUI() {
    try {
      const res = await fetch('/cart.js');
      if (!res.ok) return;
      const cart = await res.json();

      /* Badge */
      if (cartBadge) {
        if (cart.item_count > 0) {
          cartBadge.textContent = cart.item_count > 99 ? '99+' : cart.item_count;
          cartBadge.hidden = false;
        } else {
          cartBadge.hidden = true;
        }
      }

      /* Drawer items */
      const itemsContainer = document.querySelector('.luna-cart-drawer__items');
      const footerEl = document.querySelector('.luna-cart-drawer__footer');
      const emptyEl = document.querySelector('.luna-cart-empty');

      if (!itemsContainer) return;

      if (cart.item_count === 0) {
        itemsContainer.innerHTML = '';
        if (emptyEl) emptyEl.style.display = 'flex';
        if (footerEl) footerEl.style.display = 'none';
        return;
      }

      if (emptyEl) emptyEl.style.display = 'none';
      if (footerEl) footerEl.style.display = 'block';

      itemsContainer.innerHTML = cart.items.map((item) => `
        <div class="luna-cart-item" data-cart-item="${item.key}">
          <div class="luna-cart-item__image">
            <img src="${item.image}" alt="${item.title}" loading="lazy">
          </div>
          <div class="luna-cart-item__details">
            <p class="luna-cart-item__name">${item.product_title}</p>
            ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="luna-cart-item__variant">${item.variant_title}</p>` : ''}
            <div class="luna-cart-item__qty">
              <button class="luna-cart-item__qty-btn" data-qty-change="-1" data-key="${item.key}" aria-label="Diminuir quantidade">−</button>
              <span class="luna-cart-item__qty-num">${item.quantity}</span>
              <button class="luna-cart-item__qty-btn" data-qty-change="1" data-key="${item.key}" aria-label="Aumentar quantidade">+</button>
            </div>
            <p class="luna-cart-item__price">${formatBRL((item.price / 100) * item.quantity)}</p>
          </div>
          <button class="luna-cart-item__remove" data-remove-item="${item.key}" aria-label="Remover item">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
          </button>
        </div>
      `).join('');

      /* Subtotal */
      const subtotalEl = document.querySelector('.luna-cart-drawer__subtotal-price');
      if (subtotalEl) subtotalEl.textContent = formatBRL(cart.total_price / 100);

      /* Free-shipping progress */
      updateShipBar(cart.total_price);
    } catch { /* ignore */ }
  }

  /* ── Free-shipping progress bar (cart drawer) ────────────── */
  function updateShipBar(totalCents) {
    document.querySelectorAll('[data-ship-bar]').forEach((bar) => {
      const threshold = Number(bar.dataset.threshold || 19900);
      const missing = threshold - totalCents;
      const pct = Math.max(0, Math.min(100, Math.round((totalCents / threshold) * 100)));
      const text = bar.querySelector('[data-ship-text]');
      const fill = bar.querySelector('[data-ship-fill]');
      const track = bar.querySelector('[role="progressbar"]');
      if (text) {
        text.innerHTML = missing > 0
          ? 'Faltam <strong>' + formatBRL(missing / 100) + '</strong> para o frete grátis'
          : '<strong>Frete grátis garantido</strong> para o seu pedido';
      }
      if (fill) fill.style.width = pct + '%';
      if (track) track.setAttribute('aria-valuenow', String(pct));
      bar.classList.toggle('is-complete', missing <= 0);
    });
  }

  /* ── Cart quantity change / remove ───────────────────────── */
  document.addEventListener('click', async (e) => {
    const qtyBtn = e.target.closest('[data-qty-change]');
    const removeBtn = e.target.closest('[data-remove-item]');

    if (qtyBtn) {
      const key = qtyBtn.dataset.key;
      const delta = Number(qtyBtn.dataset.qtyChange);
      const qtyEl = qtyBtn.parentElement.querySelector('.luna-cart-item__qty-num');
      const currentQty = Number(qtyEl?.textContent || 1);
      const newQty = currentQty + delta;

      if (newQty <= 0) {
        await cartChange(key, 0);
      } else {
        qtyEl.textContent = newQty;
        await cartChange(key, newQty);
      }
      updateCartUI();
    }

    if (removeBtn) {
      const key = removeBtn.dataset.removeItem;
      await cartChange(key, 0);
      updateCartUI();
    }
  });

  async function cartChange(key, quantity) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity }),
      });
    } catch { /* ignore */ }
  }

  /* ── Image Carousel ──────────────────────────────────────── */
  document.querySelectorAll('.luna-carousel').forEach((carousel) => {
    const slides = carousel.querySelectorAll('.luna-carousel__slide');
    const dots = carousel.querySelectorAll('.luna-carousel__dot');
    const prevBtn = carousel.querySelector('.luna-carousel__arrow--prev');
    const nextBtn = carousel.querySelector('.luna-carousel__arrow--next');
    let current = 0;
    let startX = 0;
    let isDragging = false;

    function goTo(index) {
      slides[current]?.classList.remove('active');
      dots[current]?.classList.remove('active');
      current = (index + slides.length) % slides.length;
      slides[current]?.classList.add('active');
      dots[current]?.classList.add('active');
    }

    prevBtn?.addEventListener('click', () => goTo(current - 1));
    nextBtn?.addEventListener('click', () => goTo(current + 1));
    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));

    /* Swipe */
    carousel.addEventListener('touchstart', (e) => {
      startX = e.touches[0].clientX;
      isDragging = true;
    }, { passive: true });

    carousel.addEventListener('touchend', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    }, { passive: true });

    /* Mouse drag */
    carousel.addEventListener('mousedown', (e) => {
      startX = e.clientX;
      isDragging = true;
      e.preventDefault();
    });
    carousel.addEventListener('mouseup', (e) => {
      if (!isDragging) return;
      isDragging = false;
      const diff = startX - e.clientX;
      if (Math.abs(diff) > 50) {
        diff > 0 ? goTo(current + 1) : goTo(current - 1);
      }
    });
  });

  /* ── Variant Selector ────────────────────────────────────── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.luna-variant-btn');
    if (!btn) return;

    const group = btn.closest('.luna-variants');
    if (!group) return;

    group.querySelectorAll('.luna-variant-btn').forEach((b) => b.classList.remove('active'));
    btn.classList.add('active');

    const productId = btn.dataset.productId;
    const variantId = btn.dataset.variantId;
    const variantName = btn.dataset.variantName;

    /* Update hidden input */
    const form = btn.closest('form');
    const input = form?.querySelector('input[name="id"]');
    if (input && variantId) input.value = variantId;

    /* Update add-to-cart button data */
    const addBtn = btn.closest('.luna-product-card, .luna-product-page__info')
      ?.querySelector('[data-add-to-cart]');
    if (addBtn && variantId) addBtn.dataset.variantId = variantId;

    /* Update availability */
    if (addBtn && btn.dataset.variantAvailable !== undefined) {
      addBtn.disabled = btn.dataset.variantAvailable !== 'true';
    }

    /* Update price on product cards */
    const priceDisplay = btn.closest('.luna-product-card')?.querySelector('[data-price-display]');
    if (priceDisplay && btn.dataset.variantPrice) {
      const priceEl = priceDisplay.querySelector('.luna-price__current');
      if (priceEl) priceEl.textContent = btn.dataset.variantPrice;

      const origEl = priceDisplay.querySelector('.luna-price__original');
      const discEl = priceDisplay.querySelector('.luna-price__discount');
      if (btn.dataset.variantCompare && btn.dataset.variantCompare !== '' && btn.dataset.variantCompare !== btn.dataset.variantPrice) {
        if (origEl) { origEl.textContent = btn.dataset.variantCompare; origEl.style.display = ''; }
        if (discEl) { const c = parseFloat(btn.dataset.variantCompare.replace(/[^\d,]/g, '').replace(',', '.')); const p = parseFloat(btn.dataset.variantPrice.replace(/[^\d,]/g, '').replace(',', '.')); if (c > p) { discEl.textContent = '-' + Math.round((c - p) / c * 100) + '%'; discEl.style.display = ''; } }
      } else {
        if (origEl) origEl.style.display = 'none';
        if (discEl) discEl.style.display = 'none';
      }
    }

    /* Update price on product page */
    const pagePrice = btn.closest('.luna-product-page__info')?.querySelector('[data-product-page-price]');
    if (pagePrice && btn.dataset.variantPrice) {
      pagePrice.textContent = btn.dataset.variantAvailable === 'true'
        ? (pagePrice.textContent.includes('—') ? pagePrice.textContent.replace(/—.*/, '— ' + btn.dataset.variantPrice) : 'Comprar — ' + btn.dataset.variantPrice)
        : 'Esgotado';
    }

    /* Update "Buy now" link */
    const buyNow = btn.closest('.luna-product-card, .luna-product-page__info')
      ?.querySelector('[data-buy-now]');
    if (buyNow && variantId) {
      buyNow.dataset.variantId = variantId;
      buyNow.href = '/cart/' + variantId + ':1';
      buyNow.style.pointerEvents = btn.dataset.variantAvailable === 'true' ? '' : 'none';
      buyNow.style.opacity = btn.dataset.variantAvailable === 'true' ? '' : '0.5';
    }

    /* Update mobile sticky buy bar (product page) */
    if (btn.closest('.luna-product-page__info')) {
      document.querySelectorAll('[data-pbar]').forEach((bar) => {
        const barBtn = bar.querySelector('[data-buy-now]');
        const barPrice = bar.querySelector('[data-pbar-price]');
        const barVariant = bar.querySelector('[data-pbar-variant]');
        const ok = btn.dataset.variantAvailable === 'true';
        if (barBtn && variantId) {
          barBtn.dataset.variantId = variantId;
          barBtn.href = '/cart/' + variantId + ':1';
          barBtn.style.pointerEvents = ok ? '' : 'none';
          barBtn.style.opacity = ok ? '' : '0.5';
          barBtn.textContent = ok ? 'Comprar' : 'Esgotado';
        }
        if (barPrice && btn.dataset.variantPrice) barPrice.textContent = btn.dataset.variantPrice;
        if (barVariant && variantName) barVariant.textContent = variantName;
      });
    }

    /* Update URL without reload */
    if (variantId && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url);
    }
  });

  /* ── Scroll reveal (IntersectionObserver) ────────────────── */
  const revealEls = document.querySelectorAll('[data-reveal]');
  if (revealEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -60px 0px' }
    );

    revealEls.forEach((el, i) => {
      el.style.opacity = '0';
      el.style.transform = 'translateY(30px)';
      const delay = Math.min(i * 0.12, 0.48);
      el.style.transition = `opacity 0.7s ease ${delay}s, transform 0.7s ease ${delay}s`;
      observer.observe(el);
    });
  }

  /* ── Helpers ─────────────────────────────────────────────── */
  function formatBRL(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(value);
  }

  /* ============================================================
     VISUAL EFFECTS
     ============================================================ */

  const isDesktop = window.matchMedia('(min-width: 769px)').matches;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Firefly Particles ─────────────────────────────────── */
  if (isDesktop && !prefersReducedMotion) {
    const container = document.createElement('div');
    container.className = 'luna-fireflies';
    container.setAttribute('aria-hidden', 'true');
    document.body.appendChild(container);

    const fireflyCount = 12;
    for (let i = 0; i < fireflyCount; i++) {
      const el = document.createElement('div');
      el.className = 'luna-firefly';
      el.style.left = Math.random() * 100 + '%';
      el.style.top = 30 + Math.random() * 60 + '%';
      el.style.setProperty('--duration', (16 + Math.random() * 14) + 's');
      el.style.setProperty('--delay', (Math.random() * 12) + 's');
      el.style.setProperty('--tx', (Math.random() * 120 - 60) + 'px');
      el.style.setProperty('--ty', -(40 + Math.random() * 100) + 'px');
      el.style.setProperty('--tx2', (Math.random() * 80 - 40) + 'px');
      el.style.setProperty('--ty2', -(80 + Math.random() * 120) + 'px');
      container.appendChild(el);
    }
  }

  /* ── Cursor Glow Trail ─────────────────────────────────── */
  if (isDesktop && !prefersReducedMotion) {
    const glow = document.createElement('div');
    glow.className = 'luna-cursor-glow';
    glow.setAttribute('aria-hidden', 'true');
    document.body.appendChild(glow);

    let mouseX = 0, mouseY = 0;
    let glowX = 0, glowY = 0;
    let active = false;

    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (!active) {
        active = true;
        glow.classList.add('active');
      }
    });

    document.addEventListener('mouseleave', () => {
      active = false;
      glow.classList.remove('active');
    });

    function animateGlow() {
      glowX += (mouseX - glowX) * 0.12;
      glowY += (mouseY - glowY) * 0.12;
      glow.style.left = glowX + 'px';
      glow.style.top = glowY + 'px';
      requestAnimationFrame(animateGlow);
    }
    animateGlow();
  }

  /* ── Scroll Reveal (Enhanced) ──────────────────────────── */
  if ('IntersectionObserver' in window) {
    const revealEls = document.querySelectorAll('[data-reveal]');
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -80px 0px' }
    );
    revealEls.forEach((el, i) => {
      el.style.transitionDelay = (i * 0.15) + 's';
      observer.observe(el);
    });
  }

  /* ── Ripple Effect on Buttons ───────────────────────────── */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.luna-add-to-cart, .luna-product-page__add-btn, .luna-cart-drawer__checkout');
    if (!btn || prefersReducedMotion) return;

    const rect = btn.getBoundingClientRect();
    const ripple = document.createElement('span');
    ripple.className = 'luna-ripple';
    const size = Math.max(rect.width, rect.height);
    ripple.style.width = ripple.style.height = size + 'px';
    ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
    ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
    btn.appendChild(ripple);
    setTimeout(() => ripple.remove(), 600);
  });

  /* ── Hero Parallax ─────────────────────────────────────── */
  if (isDesktop && !prefersReducedMotion) {
    const heroBg = document.querySelector('.luna-hero__bg');
    const heroInner = document.querySelector('.luna-hero__inner');
    if (heroBg && heroInner) {
      let ticking = false;
      window.addEventListener('scroll', () => {
        if (!ticking) {
          requestAnimationFrame(() => {
            const scrollY = window.scrollY;
            const heroH = heroBg.parentElement.offsetHeight;
            if (scrollY < heroH) {
              heroBg.style.transform = 'translateY(' + (scrollY * 0.25) + 'px)';
              heroInner.style.transform = 'translateY(' + (scrollY * 0.08) + 'px)';
              heroInner.style.opacity = 1 - scrollY / heroH * 0.5;
            }
            ticking = false;
          });
          ticking = true;
        }
      });
    }
  }

  /* ── Init cart on load ───────────────────────────────────── */
    /* ── Mobile menu ─────────────────────────────────────────── */
  const navToggle = document.querySelector('[data-nav-toggle]');
  const navPanel = document.querySelector('[data-nav-panel]');
  if (navToggle && navPanel) {
    const setNav = (open) => {
      navPanel.classList.toggle('open', open);
      navToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      document.documentElement.classList.toggle('luna-nav-open', open);
    };
    navToggle.addEventListener('click', () => setNav(!navPanel.classList.contains('open')));
    navPanel.addEventListener('click', (e) => {
      if (e.target.closest('a') || e.target.closest('[data-nav-close]') || e.target === navPanel) setNav(false);
    });
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setNav(false); });
    window.matchMedia('(min-width: 769px)').addEventListener?.('change', (m) => { if (m.matches) setNav(false); });
  }

  /* ── Product page: mobile sticky buy bar ─────────────────── */
  const pbar = document.querySelector('[data-pbar]');
  const pbarAnchor = document.querySelector('.luna-product-page__buy-btn');
  if (pbar && pbarAnchor && 'IntersectionObserver' in window) {
    const pbarObs = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        pbar.classList.toggle('is-visible', passed);
        pbar.setAttribute('aria-hidden', passed ? 'false' : 'true');
      });
    }, { threshold: 0 });
    pbarObs.observe(pbarAnchor);
  }

  updateCartUI();
})();
